<template>
  <div class="height-full">
    <a-row class="m-b-10" :gutter="10">
      <a-col :span="2">
        <a-select
          class="width-full"
          placeholder="类型"
          v-model="type"
          allowClear
        >
          <a-select-option value="square">
            方仓
          </a-select-option>
          <a-select-option value="circle">
            圆仓
          </a-select-option>
        </a-select>
      </a-col>
      <a-col :span="5">
        <a-input addon-before="名称" v-model="name" placeholder="搜索内容">
          <a-icon slot="suffix" type="search" />
        </a-input>
      </a-col>
      <a-col :span="5">
        <DateRangePicker label="创建时间" v-model="rangeValue" />
      </a-col>
      <a-col :offset="10" :span="2" class="text-right">
        <a-button
          type="primary"
          @click="addData"
          v-if="can('createGrainStorehouseModel')"
        >
          新建
        </a-button>
      </a-col>
    </a-row>
    <div class="height-full">
      <tk-flex class="height-full" center middle v-if="isEmpty">
        <a-empty />
      </tk-flex>
      <div class="width-full height-full" v-else>
        <div class="min-heiget-90">
          <a-row :gutter="[16, 16]" type="flex">
            <a-col
              v-for="item in datas"
              :key="item.objectId"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="8"
              :xxl="6"
            >
              <WarestoreCard
                :warehouse="item"
                @edit="reset"
                @delete="reset"
                @click="jump(item)"
              />
            </a-col>
          </a-row>
        </div>
        <tk-flex class="m-t-20" right>
          <a-pagination
            show-quick-jumper
            v-model="current"
            :pageSize.sync="pageSize"
            :pageSizeOptions="['12', '16', '20', '24']"
            showSizeChanger
            :total="total"
            @change="onChange"
            @showSizeChange="onShowSizeChange"
          />
        </tk-flex>
      </div>
    </div>
    <a-modal
    :maskClosable="false"
      title="新增粮仓"
      :visible="showAdd"
      :confirm-loading="confirmAddLoading"
      @ok="handleAddOk"
      destroyOnClose
      @cancel="handleAddCancel"
    >
      <ak-type-input
        ref="name"
        key="name"
        v-model="formdata.name"
        :field="options[0]"
        style="width: 100%"
      />
      <ak-type-input
        ref="expectation"
        key="expectation"
        v-model="formdata.expectation"
        :field="options[1]"
        style="width: 100%"
      />
      <ak-type-input
        ref="reality"
        key="reality"
        v-model="formdata.reality"
        :field="options[2]"
        style="width: 100%"
      />
      <ak-type-input
        ref="type"
        key="type"
        v-model="formdata.type"
        :field="options[3]"
        style="width: 100%"
      />
      <ak-type-input
        ref="subtype"
        key="subtype"
        v-if="formdata.type == 'square'"
        v-model="formdata.subtype"
        :field="options[4]"
        style="width: 100%"
      />
      <ak-type-input
        ref="subtype2"
        key="subtype2"
        v-if="formdata.type == 'circle'"
        v-model="formdata.subtype"
        :field="options[5]"
        style="width: 100%"
      />
      <ak-type-input
        ref="length"
        key="length"
        v-if="formdata.type == 'square'"
        v-model="formdata.length"
        :field="options[6]"
        style="width: 100%"
      />
      <ak-type-input
        ref="width"
        key="width"
        v-if="formdata.type == 'square'"
        v-model="formdata.width"
        :field="options[7]"
        style="width: 100%"
      />
      <ak-type-input
        ref="height"
        key="height"
        v-if="formdata.type"
        v-model="formdata.height"
        :field="options[8]"
        style="width: 100%"
      />
      <ak-type-input
        ref="diameter"
        key="diameter"
        v-if="formdata.type == 'circle'"
        v-model="formdata.diameter"
        :field="options[9]"
        style="width: 100%"
      />
      <ak-type-input
        ref="grainType"
        key="grainType"
        v-model="formdata.grainType"
        :field="options[10]"
        style="width: 100%"
      />
      <ak-type-input
        ref="storageType"
        key="storageType"
        v-model="formdata.storageType"
        :field="options[11]"
        style="width: 100%"
      />
      <ak-type-input
        ref="incomeAt"
        key="incomeAt"
        v-model="formdata.incomeAt"
        :field="options[12]"
        style="width: 100%"
      />
      <ak-type-input
        ref="leaveAt"
        key="leaveAt"
        v-model="formdata.leaveAt"
        :field="options[13]"
        style="width: 100%"
      />
      <a-form-model ref="form" :model="formdata" :rules="{
        times: [{ validator: validateTimes, trigger: 'change' }]
      }">
        <a-form-model-item
          ref="times"
          label="定时拍摄"
          prop="times"
        >
          <tk-flex
            style="width: 100%"
            v-for="(item, index) in formdata.times"
            :key="item + index"
            class="m-b-10"
          >
            <a-time-picker
              style="flex-grow: 1"
              class="flex-grow m-r-10"
              format="HH:mm"
              valueFormat="HH:mm"
              v-model="formdata.times[index]"
            />
            <a-button v-if="index === formdata.times.length - 1" @click="addTimes"
              ><tk-flex middle
                ><a-icon type="plus" :style="{ fontSize: '14px' }"/></tk-flex
            ></a-button>
            <a-button v-else @click="deleteTimes(index)"
              ><tk-flex middle
                ><a-icon type="minus" :style="{ fontSize: '14px' }"/></tk-flex
            ></a-button>
          </tk-flex>
        </a-form-model-item>
      </a-form-model>
      <ak-type-input
        ref="custodianUser"
        key="custodianUser"
        v-model="formdata.custodianUser"
        :field="options[14]"
        style="width: 100%"
      />
    </a-modal>
  </div>
</template>
<script>
import { notEmpty } from '../../utils/validator'
import { mapMutations } from 'vuex'
import WarestoreCard from '../../components/warestore/card'
import DateRangePicker from '../../components/dateRangePicker'
import moment from 'moment'
import multipleTime from '../../assets/js/multipleTime'
export default {
  mixins: [
    multipleTime
  ],
  components: {
    WarestoreCard,
    DateRangePicker
  },
  data () {
    return {
      // add modal
      options: [
        {
          name: 'name',
          note: '粮仓名称',
          type: 'String',
          validators: [notEmpty()]
        },
        {
          name: 'expectation',
          note: '设计储量(kg)',
          type: 'Number',
          validators: [notEmpty()]
        },
        {
          name: 'reality',
          note: '实际储量(kg)',
          type: 'Number',
          validators: [notEmpty()]
        },
        {
          name: 'type',
          note: '仓房类型',
          type: 'Select',
          validators: [notEmpty()],
          items: {
            square: '方仓',
            circle: '圆仓'
          }
        },
        {
          name: 'subtype',
          note: '方仓类型',
          type: 'Select',
          validators: [notEmpty()],
          items: {
            bungalow: '平房仓',
            otherSquare: '其他方仓'
          }
        },
        {
          name: 'subtype1',
          note: '圆仓类型',
          type: 'Select',
          validators: [notEmpty()],
          items: {
            shallow: '浅圆仓',
            bamboo: '筒仓',
            otherCircle: '其他圆仓'
          }
        },
        {
          name: 'length',
          note: '粮仓长度(米)',
          type: 'Number',
          validators: [notEmpty()]
        },
        {
          name: 'width',
          note: '粮仓宽度(米)',
          type: 'Number',
          validators: [notEmpty()]
        },
        {
          name: 'height',
          note: '粮面高度(米)',
          type: 'Number',
          validators: [notEmpty()]
        },
        {
          name: 'diameter',
          note: '粮仓直径(米)',
          type: 'Number',
          validators: [notEmpty()]
        },
        {
          name: 'grainType',
          note: '粮食品种',
          type: 'Select',
          validators: [notEmpty()],
          items: {}
        },
        {
          name: 'storageType',
          note: '储量性质',
          type: 'Select',
          validators: [notEmpty()],
          items: {}
        },
        {
          name: 'incomeAt',
          note: '入仓时间',
          type: 'Date',
          span: 24,
          validators: [notEmpty()]
        },
        {
          name: 'leaveAt',
          note: '计划出仓时间',
          type: 'Date',
          span: 24,
          validators: []
        },
        {
          name: 'custodianUser',
          note: '保管员',
          type: 'String',
          validators: [notEmpty()]
        }
      ],
      showAdd: false,
      confirmAddLoading: false,
      formdata: {
        name: undefined,
        expectation: undefined,
        reality: undefined,
        type: undefined,
        subtype: undefined,
        length: undefined,
        width: undefined,
        height: undefined,
        diameter: undefined,
        grainType: undefined,
        storageType: undefined,
        incomeAt: undefined,
        leaveAt: undefined,
        times: [''],
        custodianUser: undefined
      },
      // list + page
      datas: [],
      total: 0,
      pageSize: 12,
      current: 1,
      // filter
      name: null,
      type: undefined,
      rangeValue: []
    }
  },
  computed: {
    isEmpty () {
      return this.datas && this.datas.length === 0
    },
    filterObj () {
      const json = { grainWarehouse: this.depotId }
      if (this.name) {
        json['name'] = { $regex: this.name }
      }
      if (this.rangeValue && this.rangeValue.length > 0) {
        json['createdAt'] = {
          $gt: moment(this.rangeValue[0])
            .startOf('day')
            .toISOString(),
          $lte: moment(this.rangeValue[1])
            .endOf('day')
            .toISOString()
        }
      }
      if (this.type) {
        json['type'] = this.type
      }
      return json
    },
    depotId () {
      return this.$route.query['depot']
    },
    hid () {
      return this.$route.query['hid']
    }
  },
  watch: {
    filterObj () {
      this.current = 1
      this.init()
    },
    'formdata.type' (newV) {
      this.formdata.subtype = undefined
    },
    'formdata.times' (newV) {
      if (this.$refs.times) {
        this.$refs.times.onFieldChange()
      }
    }
  },
  mounted () {
    this.getGrains()
    this.getStorage()
    this.init()
    this.getDeportInfo()
  },
  beforeDestroy () {
    // this.
    this.setPageTitle('')
  },
  methods: {
    ...mapMutations(['setPageTitle']),
    async getDeportInfo () {
      const res = await this.$tkParse.get('/classes/grainWarehouse', {
        params: {
          where: {
            objectId: this.depotId
          }
        }
      })
      this.setPageTitle(res.data.results[0].name)
    },
    addTimes () {
      this.formdata.times.push('')
    },
    deleteTimes (index) {
      this.formdata.times.splice(index, 1)
    },
    resetFormat () {
      this.formdata = {
        name: undefined,
        expectation: undefined,
        reality: undefined,
        type: undefined,
        subtype: undefined,
        length: undefined,
        width: undefined,
        height: undefined,
        diameter: undefined,
        grainType: undefined,
        storageType: undefined,
        incomeAt: undefined,
        leaveAt: undefined,
        custodianUser: undefined,
        times: ['']
      }
    },
    jump (item) {
      if (this.can('viewGrainStorehouseModel')) {
        this.$router.push({
          path: '/grainstore/detail',
          query: { store: item.objectId, type: 'summary' }
        })
      }
    },
    transformItems (list) {
      const json = {}
      list.forEach(element => {
        json[element.objectId] = element.name
      })
      return json
    },
    async getGrains () {
      const res = await await this.$tkParse.get('/classes/storageInfo', {
        params: {
          where: {
            types: 'grain'
          },
          limit: Number.MAX_SAFE_INTEGER
        }
      })
      this.options[10].items = this.transformItems(res.data.results)
    },
    async getStorage () {
      const res = await this.$tkParse.get('/classes/storageInfo', {
        params: {
          where: {
            types: 'storage'
          },
          limit: Number.MAX_SAFE_INTEGER
        }
      })
      this.options[11].items = this.transformItems(res.data.results)
    },
    async validate () {
      const ret = []
      const refskey = Object.keys(this.$refs)
      for (let index = 0; index < refskey.length; index++) {
        const element = refskey[index]
        if (this.$refs[element]) {
          let item
          try {
            item = await this.$refs[element].validate()
          } catch (e) {
            item = e
          }
          if (item === true) {
            ret.push('')
          } else if (item === false) {
            ret.push('error')
          } else {
            ret.push(item)
          }
        }
      }
      const errors = ret.filter(element => element)
      if (errors.length > 0) {
        return false
      } else {
        const ret = this.checkTimeIntervals(this.sortUniq(this.formdata.times).filter(item => item))
        if (!ret) {
          this.$notification['error']({
            message: '定时设置',
            description: '设置的时间间隔需要在1小时以上，请检查设置的定时设置'
          })
        }
        return ret
      }
    },
    validateTimes (rule, value, callback) {
      // callback()
      if (this.formdata.times.some(item => item)) callback()
      else callback(new Error('请选择定时拍照时间'))
    },
    async handleAddOk () {
      this.confirmLoading = true
      await this.submit()
      this.showAdd = false
      this.confirmLoading = false
      this.reset()
    },
    handleAddCancel () {
      this.showAdd = false
    },
    addData () {
      this.resetFormat()
      this.showAdd = true
      this.confirmLoading = false
    },
    formatTimes () {
      const newTimes = this.sortUniq(this.formdata.times)
      if (newTimes.length !== this.formdata.times.length) {
        this.$notification['info']({
          message: '定时设置',
          description: '时间相同的设置只会保存一个'
        })
      }
      return newTimes.filter(item => item).join('@')
    },
    async submit () {
      const flag = await this.validate()
      if (flag) {
        if (this.formdata.type === 'square') {
          this.formdata.diameter = undefined
        } else {
          this.formdata.width = undefined
          this.formdata.length = undefined
        }
        const times = this.formatTimes()
        await this.$tkParse.post('/classes/grainStorehouse', {
          name: this.formdata.name,
          expectation: this.formdata.expectation,
          reality: this.formdata.reality,
          type: this.formdata.type,
          subtype: this.formdata.subtype,
          length: this.formdata.length,
          width: this.formdata.width,
          height: this.formdata.height,
          diameter: this.formdata.diameter,
          grainType: this.formdata.grainType,
          storageType: this.formdata.storageType,
          incomeAt: this.formdata.incomeAt,
          leaveAt: this.formdata.leaveAt,
          custodianUser: this.formdata.custodianUser,
          grainWarehouse: this.depotId,
          bugNum: 0,
          hierarchy: this.hid,
          times: times
        })
        this.resetFormat()
      }
    },
    async init () {
      this.$loading.show()
      this.datas = []
      const results = await Promise.all([
        this.queryListInfo(),
        this.queryInfoSum()
      ])
      this.datas = results[0]
      this.total = results[1]
      this.$loading.hide()
    },
    async reset () {
      this.$loading.show()
      this.datas = []
      const results = await Promise.all([this.queryListInfo()])
      this.datas = results[0]
      this.$loading.hide()
    },
    async queryListInfo () {
      const res = await this.$tkParse.get('/classes/grainStorehouse', {
        params: {
          order: '-createdAt',
          where: this.filterObj,
          limit: this.pageSize,
          skip: (this.current - 1) * this.pageSize
        }
      })
      return res.data.results
    },
    async queryInfoSum () {
      const res = await this.$tkParse.get('/classes/grainStorehouse', {
        params: {
          where: this.filterObj,
          limit: Number.MAX_SAFE_INTEGER,
          keys: 'objectId'
        }
      })
      return res.data.results.length
    },
    async onChange () {
      this.$loading.show()
      this.datas = await this.queryListInfo()
      this.$loading.hide()
    },
    onShowSizeChange () {
      this.current = 1
      this.init()
    }
  }
}
</script>
<style scoped>
::v-deep .ant-calendar-picker {
  width: 100%;
}
</style>
